/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Bug16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M1.5 4a.5.5 0 011 0c0 .933.642 1.718 1.506 1.938v-.04l.002-.013a1.992 1.992 0 011.537-1.874c-.015-.119-.045-.233-.045-.353C5.5 2.191 6.62 1 8 1c1.379 0 2.5 1.191 2.5 2.658 0 .12-.033.234-.05.352A1.997 1.997 0 0112 5.954v-.017A2.003 2.003 0 0013.5 4a.5.5 0 011 0A3.005 3.005 0 0112 6.958V8h2.5a.5.5 0 01.09.992L14.5 9H12v1.042A3.005 3.005 0 0114.5 13a.5.5 0 01-1 0c0-.936-.645-1.723-1.513-1.94-.011.235-.026.385-.037.384C11.706 13.419 10.04 15 8 15c-2.02 0-3.673-1.548-3.943-3.492a15.627 15.627 0 01-.046-.447A2.002 2.002 0 002.5 13a.5.5 0 01-1 0A3.006 3.006 0 014 10.042V9H1.5a.5.5 0 010-1H4v-.08c.002-.372.002-.693.002-.964A3.001 3.001 0 011.5 4M10 5H6c-.552 0-1 .402-1 .954v5.001C5 12.437 6.084 13.761 7.5 14V8.954a.5.5 0 011 0V14c1.416-.24 2.5-1.564 2.5-3.046v-5C11 5.402 10.552 5 10 5M8 2c-.826 0-1.5.744-1.5 1.658 0 .102.02.244.037.342h2.922c.017-.1.04-.24.04-.342C9.5 2.744 8.828 2 8 2"
        />
    </AccessibleSVG>
);

export default Bug16;
